import React, { useCallback } from 'react'
import { Avatar } from '@components/Avatar/Avatar'
import { ZChannelPropertiesEvent } from '@components/MessageTimeline/util/getEventsByDate'
import { ProfileHoverCard } from '@components/ProfileHoverCard/ProfileHoverCard'
import { Box, Paragraph, Stack, Text } from '@ui'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'
import { useUserLookupContext } from 'use-towns-client'
import { getPrettyDisplayName } from 'utils/getPrettyDisplayName'

export type Props = {
    event: ZChannelPropertiesEvent
    userId?: string
}

export const RoomProperties = (props: Props) => {
    const { lookupUser } = useUserLookupContext()
    const { event, userId } = props
    const creator = event.sender.id
    const groupName = event.content.properties.name
    const creatorUser = lookupUser(creator)
    const name = getPrettyDisplayName(creatorUser)

    const { openPanel } = usePanelActions()

    const handleCreatorClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault()
            if (creator) {
                openPanel('profile', { profileId: creator })
            }
        },
        [openPanel, creator],
    )

    if (!creatorUser) {
        return (
            <Stack centerContent paddingX="lg" paddingY="sm" color="gray2">
                {groupName} was created
            </Stack>
        )
    }

    const action = groupName ? (
        <>
            changed the group name to{' '}
            <Text display="inline" color="default">
                {groupName}
            </Text>
        </>
    ) : (
        'removed the group name'
    )

    const message =
        creator === userId ? (
            <Stack horizontal display="inline">
                You {action}
            </Stack>
        ) : (
            <Stack horizontal display="inline">
                <Box
                    display="inline"
                    color="default"
                    cursor="pointer"
                    data-testid="creator-name-clickable"
                    onClick={handleCreatorClick}
                >
                    {name}
                </Box>{' '}
                {action}
            </Stack>
        )

    return (
        <Stack centerContent paddingX="lg" paddingY="sm" color="gray2">
            <Stack
                centerContent
                direction={{ default: 'row', mobile: 'column' }}
                gap="sm"
                tooltip={<ProfileHoverCard userId={creator} />}
            >
                <Avatar userId={creator} size="avatar_xs" />
                <Paragraph textAlign={{ mobile: 'center' }}>{message}</Paragraph>
            </Stack>
        </Stack>
    )
}
